import React, { useContext, useEffect, useState } from 'react'
import moment from 'moment'
import { ClientPortalContext } from '../../ClientPortal'
import API from '../../../../../services/API'
import DetailsBox, {
  DetailRow,
} from '../../../../../components/Cards/DetailsBox'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Grid from '@mui/material/Grid'
import LinearProgress from '@mui/material/LinearProgress'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import ReplyIcon from '@mui/icons-material/Reply'
import { isFullWidth } from 'validator'
import { Alert } from '@mui/material'
import EventInfo from './EventInfo'
import Messages from './Messages'
import PrimaryContact from './PrimaryContact'
import PostEventAnalysis from './PostEventAnalysis'
import RIDDOR from './RIDDOR'
import MedicalPlan from './MedicalPlan'
import { useLocation, useNavigate, useParams } from 'react-router-dom'

const Event = () => {
  const [loading, setLoading] = useState(true)
  const [fetchError, setFetchError] = useState(false)
  const [event, setEvent] = useState({})
  const navigate = useNavigate()

  const { eventID } = useParams()

  useEffect(() => {
    API.get('/client-portal/event/' + eventID)
      .then((res) => {
        if (res.status === 200) {
          setEvent(res.data)
        } else {
          setFetchError(true)
        }
      })
      .catch(() => setFetchError(true))
      .finally(() => setLoading(false))
  }, [])

  return (
    <Box
      display="flex"
      padding={2}
      width="100%"
      borderRadius={2}
      border="solid 2px"
      borderColor="primary.main"
    >
      {loading ? (
        <LinearProgress />
      ) : (
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Stack
              direction={{ xs: 'column', lg: 'row' }}
              gap={1}
              alignItems="center"
            >
              <Button
                startIcon={<ReplyIcon />}
                variant="contained"
                size="small"
                onClick={() => navigate('/events')}
              >
                Back
              </Button>
              <Typography variant="title2" textAlign="center" flex={1}>
                {event.title}
              </Typography>
            </Stack>
          </Grid>
          {event?.cancellationReason && event.status === 'Cancelled' && (
            <Grid item xs={12}>
              <Alert severity="warning">This Event has been Cancelled</Alert>
            </Grid>
          )}
          {fetchError ? (
            <Grid item xs={12}>
              <Alert severity="error" variant="filled">
                Unable to fetch this Event. Please try again later.
              </Alert>
            </Grid>
          ) : (
            <>
              <EventInfo event={event} />
              <PrimaryContact event={event} setEvent={setEvent} />
              <Messages eventID={event._id} />
              <MedicalPlan event={event} />
              <RIDDOR event={event} />
              <PostEventAnalysis event={event} setEvent={setEvent} />
            </>
          )}
        </Grid>
      )}
    </Box>
  )
}

export default Event
